import { styled } from 'styled-components'

export const NewServiceViewContainer = styled.div`
  margin-top: 1.5rem;
`

export const FormInputContainer = styled.div`
  margin-bottom: 1rem;

  .selectBottomSheet {
    width: 100vw;
  }
`

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  gap: 0.2rem;
`

export const UploadContainer = styled.div`
  margin-top: 0.5rem;
`
